<form [formGroup]="formularioImputacion" class="form-group" novalidate>
  <div class="row">
    <div *ngIf="!loading" class="form-group col-md-6">
      <app-lfsa-combo-box (change)="changeTipoImputacion()"
                          [comboBox]="cmbTipoImputacion"
                          [control]="formularioImputacion.get('tipoImputacion') | formControl" [idOpcion]="'id'"
                          [id]="'tipoImputacion'"
                          [label]="'Tipo imputación*'"
                          [opcion]="'descripcion'"
                          formControlName="tipoImputacion">
      </app-lfsa-combo-box>
    </div>
    <div *ngIf="!loading" class="form-group col-md-6">
      <app-lfsa-combo-box [comboBox]="cmbElemento"
                          [control]="formularioImputacion.get('elemento') | formControl"
                          [habilitar]="!(this.formularioImputacion &&
                                        this.formularioImputacion.get('tipoImputacion') &&
                                        this.formularioImputacion.get('tipoImputacion').value !== '')"
                          [idOpcion]="'id'" [id]="'elemento'"
                          [label]="'Elemento*'"
                          [opcion]="'descripcion'"
                          (change)="changeElement()"
                          formControlName="elemento">
      </app-lfsa-combo-box>
    </div>
    <div *ngIf="!loading" class="form-group col-md-6">
      <app-lfsa-input [control]="formularioImputacion.get('porcentaje') | formControl" [id]="'porcentaje'"
                      [label]="'Porcentaje*'" [mostrarImg]="false"
                      [placeholder]="'Porcentaje'"
                      [rutaImagen]=""
                      [type]="'number'"
                      formControlName="porcentaje">
      </app-lfsa-input>
      <div *ngIf="formularioImputacion.get('porcentaje').errors">
        <div *ngIf="formularioImputacion.get('porcentaje').errors.sumaPorcentajesExcede" class="invalid-feedback">
          {{ DAT_MSG.getSumaPorcentajesErrorMessage }}
        </div>
        <div *ngIf="formularioImputacion.get('porcentaje').errors.invalidPorcentaje" class="invalid-feedback">
          {{ DAT_MSG.getInvalidPorcentajeErrorMessage }}
        </div>
        <div *ngIf="formularioImputacion.get('porcentaje').errors.outOfRange" class="invalid-feedback">
          {{ DAT_MSG.getOutOfRangeErrorMessage }}
        </div>
      </div>
    </div>
    <div *ngIf="!loading" class="form-group col-md-6">
      <app-lfsa-input [control]="formularioImputacion.get('importeImputacion') | formControl"
                      [id]="'importeImputacion'"
                      [isReadOnly]="true"
                      [label]="'Valor*'" [mostrarImg]="false"
                      [placeholder]="'Valor'"
                      [rutaImagen]=""
                      [type]="'number'"
                      formControlName="importeImputacion">
      </app-lfsa-input>
    </div>
  </div>
  <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )"
                               [formularioValido]="formularioImputacion.invalid"
                               [loading]="loading" [textBoton]="textBoton">
  </app-lfsa-botones-formulario>
</form>
